import http from "src/_services/httpService";
import { $BASE_URL } from "src/constants";
const apiUrl = $BASE_URL + '/api';
const apiEndpoint = apiUrl + "/v1/admin-panel/admin"
const url_admin_merchant = apiUrl + "/v1/admin-panel/merchant";

function adminUrl(id) {
    return `${apiEndpoint}/${id}`;
}

const createAdmin = (admin) => {
    return http.post(apiEndpoint, admin);
}

const getAdmins = () => {
    return http.get(apiEndpoint);
}

const getAdmin = (adminId) => {
    return http.get(adminUrl(adminId));
}

const updateAdmin = (adminId, admin) => {
    return http.put(adminUrl(adminId), admin);
}

const deleteAdmin = (adminId) => {
    return http.delete(adminUrl(adminId));
}

const getMerchants = (params) => {
    if (!params.searchKey) {
        params.searchKey = !!params.searchKey ? params.searchKey : null
    }
    return http.get(url_admin_merchant, { params });
}


const updateSalla = (id, payload) => {
    return http.put(`${url_admin_merchant}/update-salla/${id}`, payload)
}

const AdminService = {
    createAdmin,
    getAdmins,
    getAdmin,
    updateAdmin,
    deleteAdmin,
    getMerchants,
    updateSalla
};

export default AdminService;
